import React from 'react'
import { Link } from 'react-router-dom'

import { Space, Result } from 'antd-mobile'
import { HomeOutlined } from '@ant-design/icons'

import { useAuth } from '../../contexts/AuthContextProvider'

const NotFoundPage = () => {
  const { userId } = useAuth()
  return (
    <Space justify='center' block style={{ marginTop: '25%' }}>
      <Link to={(userId) ? '/admin' : '/login'} style={{ textDecoration: 'none', color: 'black' }}>
        <Result
          icon={<HomeOutlined style={{ fontSize: 48, color: '#ff8f1f' }} />}
          title='Not found!'
          description='Sorry, the page you visited does not exist.'
        />
      </Link>
    </Space>
  )
}

export default NotFoundPage
